module.exports = __webpack_public_path__ + "img/square-phone-flip.5be0c688.svg";